class PostCodeDirective {
    constructor() {
        this.restrict = 'A';
        this.require = 'ngModel';
    }

    link(scope, element, attrs, modelCtrl) {
        function transformPL(inputValue) {
            if (!inputValue || inputValue === '') return '';

            let transformedInput = inputValue.replace(/[^\d]/g, '');

            if (transformedInput.length > 5) {
                transformedInput = transformedInput.substring(0, 5);
            }

            if (transformedInput.length >= 2) {
                transformedInput = `${transformedInput.substring(0, 2)}-${transformedInput.substring(2, 5)}`;
            }

            return transformedInput;
        }

        function applyTransform(inputValue, country) {
            if (!inputValue || inputValue === '') return inputValue;
            if (country === 'Polska') {
                return transformPL(inputValue);
            }
            return inputValue;
        }

        function getCountry() {
            const parts = attrs.ngModel.split('.');
            if (parts.length > 1) {
                const root = scope[parts[0]];
                if (root && root.country) {
                    return root.country;
                }
            }
            return 'Polska';
        }

        modelCtrl.$parsers.push((inputValue) => {
            const country = getCountry();
            const transformedInput = applyTransform(inputValue, country);

            if (transformedInput !== inputValue) {
                modelCtrl.$setViewValue(transformedInput);
                modelCtrl.$render();
            }
            return transformedInput;
        });

        modelCtrl.$formatters.push((inputValue) => {
            const country = getCountry();
            return applyTransform(inputValue, country);
        });

        scope.$watch(getCountry, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                const currentValue = modelCtrl.$viewValue;
                const transformed = applyTransform(currentValue, newVal);
                if (transformed !== currentValue) {
                    modelCtrl.$setViewValue(transformed);
                    modelCtrl.$render();
                }
            }
        });
    }

    static directiveFactory() {
        'ngInject';
        return new PostCodeDirective();
    }
}

export default PostCodeDirective;
